var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.079 13.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-burn",
    transform: "translate(0.5 0.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_641",
    "data-name": "Trac\\xE9 641",
    d: "M5.561,8.844a6.163,6.163,0,0,1,1.6,4.118,5.042,5.042,0,0,0,3.42-4.774c0-.022,0-.044,0-.065s0-.022,0-.032,0-.022,0-.032,0-.043,0-.064l0,.195c0-.022,0-.044,0-.065s0-.022,0-.032,0-.022,0-.032,0-.043,0-.064C10.466,4.966,7.815,3.871,8.083.62c0,0-2.544.5-3.524,4.539A4.349,4.349,0,0,1,4.3,1.881C2.7,3.012.709,5.276.515,7.792v0c0,.025,0,.049,0,.073s0,.047,0,.071c0,.04,0,.08,0,.12v.005c0,.021,0,.042,0,.062s0,.042,0,.063A5.362,5.362,0,0,0,4,12.99,5.8,5.8,0,0,1,5.561,8.844Z",
    transform: "translate(-0.5 -0.62)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/burn.4c4426b471a0e2649f689608453f1fc3.svg";
export { ForwardRef as ReactComponent };